function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.287 3.893a.8.8 0 00-1.574-.286L14.878 8.2h-4.374l.783-4.307a.8.8 0 00-1.574-.286L8.878 8.2H4.09a.8.8 0 100 1.6h4.496l-.8 4.4H3a.8.8 0 000 1.6h4.496l-.783 4.307a.8.8 0 101.574.286l.835-4.593h4.374l-.783 4.307a.8.8 0 001.574.286l.835-4.593h4.787a.8.8 0 000-1.6h-4.496l.8-4.4H21a.8.8 0 000-1.6h-4.496zm-3.5 10.307l.8-4.4h-4.374l-.8 4.4z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgHash;